import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import React from "react";
import isGHMC, { formattedDate, getCurrentDateTime1 } from "../../../Common/helper/helpar";
import { GetZone } from "../../../Apis/organizationApi";
import Loader from "../../../Common/Loader/loader";
import { useState } from "react";
import ExcelJS from "exceljs";
import { useEffect } from "react";
import SecondaryCollectionReportStore from "./store/secondaryCollectionReportStore";
const SecondaryCollectionReport = () => {
    const { fetchSecondaryCollectionReportsApi, secondaryReportsData, loading } = SecondaryCollectionReportStore()
    const isProd = isGHMC();

    const headerStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        color: "#fff",
        backgroundColor: isProd ? "#0d5da5" : "#EC1117",
    };

    const cellStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        whiteSpace: "normal",
    };

    const dateCellStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        whiteSpace: "normal",
        minWidth: "120px", // Increased width for date column
        width: "120px",
    };

 const formatDateForDisplay = (dateString) => {
    if (!dateString || isNaN(new Date(dateString).getTime())) {
        return "N/A";
    }

    const date = new Date(dateString);
    const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    };
    return date.toLocaleString("en-GB", options).replace(",", "");
};


    const [startDate, setStartDate] = useState(getStartOfCurrentDate());
    const [endDate, setEndDate] = useState(getCurrentDateTime());
    const [vehicleNumber, setVehicleNumber] = useState("");
    const [allZones, setAllZones] = useState("");
    const [zoneId, setZoneId] = useState("");

    const fetchAllZoneData = async () => {
        try {
            const zonesData = await GetZone();
            setAllZones(zonesData);
        } catch (error) {
            console.error("Error fetching initial data:", error);
        }
    };

    useEffect(() => {
        fetchAllZoneData();
        fetchSecondaryCollectionReportsApi(startDate, endDate, zoneId, vehicleNumber);
    }, []);



    const handleFormSubmit = (e) => {
        e.preventDefault();
        fetchSecondaryCollectionReportsApi(startDate, endDate, zoneId, vehicleNumber);
    };
    const options = { day: "numeric", month: "numeric", year: "numeric" };
    const generationTime = ` ${new Date().toLocaleString("en-GB", options).replace(/\//g, "/")}`;
   const downloadAsExcel = async () => {
  const currentDate = new Date();
  const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
  const reportTitle = `Secondary Collection Report ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)} - (at ${getCurrentDateTime1()})`;
  const reportTimestamp = `Report on: ${generationTime}, ${formattedTime}`;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Secondary Collection Report");

  const boldFont = { bold: true };
  const centerAlign = { horizontal: "center", vertical: "middle", wrapText: true };
  const headerFill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "F6B1B1" }, // Light red background
  };
  const borderStyle = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Row 1
  worksheet.mergeCells("A1:AG1");
  const cellA1 = worksheet.getCell("A1");
  cellA1.value = reportTimestamp;
  cellA1.font = boldFont;
  cellA1.alignment = centerAlign;
  cellA1.border = borderStyle;

  // Row 2
  worksheet.mergeCells("A2:AG2");
  const cellA2 = worksheet.getCell("A2");
  cellA2.value = reportTitle;
  cellA2.font = boldFont;
  cellA2.alignment = centerAlign;
//   cellA2.fill = headerFill;
  cellA2.border = borderStyle;

  // Static Header Columns
  const staticHeaders = [
    { cell: "A3", value: "S.No" },
    { cell: "B3", value: "Zone" },
    { cell: "C3", value: "Ward" },
    { cell: "D3", value: "Date" },
    { cell: "E3", value: "Type of Vehicle" },
    { cell: "F3", value: "Vehicle No" },
    { cell: "G3", value: "Departure TS ID" },
    { cell: "H3", value: "Destination TS ID" },
     
  ];

  staticHeaders.forEach(({ cell, value }) => {
    worksheet.getCell(cell).value = value;
    worksheet.getCell(cell).font = boldFont;
    worksheet.getCell(cell).alignment = centerAlign;
    worksheet.getCell(cell).fill = headerFill;
    worksheet.getCell(cell).border = borderStyle;
  });

  // Merge static header cells
  worksheet.mergeCells("A3:A5");
  worksheet.mergeCells("B3:B5");
  worksheet.mergeCells("C3:C5");
  worksheet.mergeCells("D3:D5");
  worksheet.mergeCells("E3:E5");
  worksheet.mergeCells("F3:F5");
  worksheet.mergeCells("G3:G5");
  worksheet.mergeCells("H3:H5"); 
  

  // Trip headers
  const tripHeaders = ["Trip Start Time", "Trip End Time", "Tare Weight", "Gross Weight", "Net Weight", "MSW Type"];
  const tripGroups = ["TRIP 1", "TRIP 2", "TRIP 3", "TRIP 4", "TRIP 5"];

  tripGroups.forEach((trip, i) => {
    const startCol = 9 + i * 6;
    worksheet.mergeCells(3, startCol, 3, startCol + 5);
    const cell = worksheet.getCell(3, startCol);
    cell.value = trip;
    cell.font = boldFont;
    cell.alignment = centerAlign;
    cell.fill = headerFill;
    cell.border = borderStyle;
  });

  // Subheaders (Row 4)
  const row4 = worksheet.getRow(4);
  row4.values = [
    "", "", "", "", "", "", "",
    ...tripGroups.flatMap(() => tripHeaders),
  ];
  row4.eachCell(cell => {
    cell.font = boldFont;
    cell.alignment = centerAlign;
    cell.fill = headerFill;
    cell.border = borderStyle;
  });

  // Data Rows
  secondaryReportsData?.forEach((item, index) => {
    const trips = item.trips || [];
    const filledTrips = Array.from({ length: 5 }, (_, i) => trips[i] || {});

    worksheet.addRow([
      index + 1,
      item.zone || "N/A",
      item.wardName || "N/A",
      formatDateForDisplay(item.date),
      item.typeofVehicle || "N/A",
      item.vehicleNumber || "N/A",
      item.departureTransferStationName ?? "N/A",
      item.destinationTransferStationName ?? "N/A",
      ...filledTrips.flatMap(trip => [
        formatDateForDisplay(trip.tripStartTime),
        formatDateForDisplay(trip.tripEndTime),
        trip.tareWeight ?? "N/A",
        trip.grossWeight ?? "N/A",
        trip.netWeight ?? "N/A",
        trip.mswType || "N/A",
      ])
    ]);
  });

  worksheet.columns.forEach(col => {
    col.width = 20;
  });

  worksheet.views = [{ state: 'frozen', ySplit: 5 }];

  worksheet.eachRow({ includeEmpty: true }, row => {
    row.eachCell(cell => {
      cell.border = borderStyle;
      cell.alignment = { ...cell.alignment, wrapText: true };
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "Secondary Collection Report.xlsx";
  a.click();
  URL.revokeObjectURL(url);
};


    return (
        <div style={{ width: "100%" }}>
            {loading && <Loader />}
            <div className="content mb-3">
                <div className="page-content">
                    <h4 className="text-start mb-3">
                        <span>Secondary Collection Report {formatDateForDisplay(startDate)} to {formatDateForDisplay(endDate)} - (at {getCurrentDateTime1()})</span>
                    </h4>
                    <div className="page-header text-start">
                        <div className="card">
                            <div className="card-body p-3">
                                <div className="row align-items-end mb-3">
                                    <div className="col-md-12">
                                        <form onSubmit={handleFormSubmit}>
                                            <div className="row" style={{ textAlign: "left" }}>
                                                <div className="col-md-2">
                                                    <label>From Date & Time:</label>
                                                    <input
                                                        type="datetime-local"
                                                        name="FromDate"
                                                        style={inputStyle}
                                                        value={startDate}
                                                        className="form-control"
                                                        max={endDate ? endDate : getCurrentDateTime()}
                                                        onChange={(e) => setStartDate(e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <label>To Date & Time:</label>
                                                    <input
                                                        type="datetime-local"
                                                        name="ToDate"
                                                        style={inputStyle}
                                                        value={endDate}
                                                        className="form-control"
                                                        min={startDate}
                                                        max={getCurrentDateTime()}
                                                        onChange={(e) => setEndDate(e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <label>Vehicle Number</label>
                                                    <input
                                                        type="text"
                                                        name="vehicleTypeCode"
                                                        style={inputStyle}
                                                        placeholder="Vehicle Number"
                                                        className="form-control"
                                                        value={vehicleNumber}
                                                        onChange={(e) => {
                                                            setVehicleNumber(e.target.value.replace(/\s+/g, ""));
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="ZoneId">Zone:</label>
                                                    <select
                                                        name="ZoneId"
                                                        className="form-select"
                                                        value={zoneId}
                                                        onChange={(e) => setZoneId(e.target.value)}
                                                    >
                                                        <option value="">Select</option>
                                                        {allZones &&
                                                            allZones
                                                                ?.filter((zone) => zone.isActive)
                                                                .map((zone) => (
                                                                    <option key={zone.zoneId} value={zone.zoneId}>
                                                                        {zone.zoneName}
                                                                    </option>
                                                                ))}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="d-flex justify-content-between">
                                                        <button
                                                            type="submit"
                                                            className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                                                        >
                                                            Search
                                                        </button>
                                                        <button className="btn btn-excel ms-auto mt-4"
                                                            onClick={downloadAsExcel}
                                                        >
                                                            <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <TableContainer
                                    component={Paper}
                                    sx={{
                                        width: "100%",
                                        border: "1px solid #ccc",
                                        maxHeight: 700,
                                    }}
                                >
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead
                                            className={`${isProd ? "bg-ghmc" : "bg-swm"}`}
                                            style={{ position: "sticky", top: 0 }}
                                        >
                                            <TableRow>
                                                <TableCell rowSpan={3} sx={headerStyles}>S.No</TableCell>
                                                <TableCell rowSpan={3} sx={headerStyles}>Zone</TableCell>
                                                 <TableCell rowSpan={3} sx={headerStyles}>Ward</TableCell>
                                                <TableCell rowSpan={3} sx={headerStyles} >Date</TableCell>
                                                <TableCell rowSpan={3} sx={headerStyles}>Type of Vehicle</TableCell>
                                                <TableCell rowSpan={3} sx={headerStyles}>Vehicle No</TableCell>
                                                <TableCell rowSpan={3} sx={headerStyles}>PCTS/FCTS Starting Location</TableCell>
                                                <TableCell rowSpan={3} sx={headerStyles}>PCTS/FCTS Ending Location</TableCell>
                                            </TableRow>

                                            <TableRow>
                                                {[1, 2, 3, 4, 5].map((trip) => (
                                                    <React.Fragment key={`trip-${trip}`}>
                                                        <TableCell colSpan={6} sx={headerStyles}>TRIP {trip}</TableCell>
                                                    </React.Fragment>
                                                ))}

                                            </TableRow>

                                            <TableRow>
                                                {[1, 2, 3, 4, 5].map((trip) => (
                                                    <React.Fragment key={`actual-time-${trip}`}>
                                                        <TableCell sx={headerStyles}>Trip Start Time</TableCell>
                                                        <TableCell sx={headerStyles}>Trip End Time</TableCell>
                                                        <TableCell sx={headerStyles}>Tare Weight</TableCell>
                                                        <TableCell sx={headerStyles}>Gross Weight</TableCell>
                                                        <TableCell sx={headerStyles}>Net Weight</TableCell>
                                                        <TableCell sx={headerStyles}>MSW Type</TableCell>
                                                    </React.Fragment>
                                                ))}

                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {secondaryReportsData?.length > 0 ? (
                                                secondaryReportsData.map((item, index) => {
                                                    const trips = item.trips || [];
                                                    const filledTrips = Array.from({ length: 5 }, (_, i) => trips[i] || {});

                                                    return (
                                                        <TableRow key={`row-${index}`} sx={{
                                                            backgroundColor: isProd
                                                                ? index % 2 === 0 ? "#8fc9ff" : "#aed8ff"
                                                                : index % 2 === 0 ? "#F8CCCD" : "#ffeded",
                                                        }}>
                                                            <TableCell sx={cellStyles}>{index + 1}</TableCell>
                                                            <TableCell sx={cellStyles}>{item.zone || "N/A"}</TableCell>
                                                              <TableCell sx={cellStyles}>{item.wardName || "N/A"}</TableCell>
                                                            <TableCell sx={dateCellStyles}>{formattedDate(item.date) || "N/A"}</TableCell>
                                                            <TableCell sx={cellStyles}>{item.typeofVehicle || "N/A"}</TableCell>
                                                            <TableCell sx={cellStyles}>{item.vehicleNumber || "N/A"}</TableCell>
                                                            <TableCell sx={cellStyles}>{item.departureTransferStationName ?? "N/A"}</TableCell>
                                                            <TableCell sx={cellStyles}>{item.destinationTransferStationName ?? "N/A"}</TableCell>
                                                            {filledTrips.map((trip, idx) => (
                                                                <React.Fragment key={`trip-data-${idx}`}>
                                                                    <TableCell sx={cellStyles}>{formatDateForDisplay(trip.tripStartTime) || "N/A"}</TableCell>
                                                                    <TableCell sx={cellStyles}>{formatDateForDisplay(trip.tripEndTime) || "N/A"}</TableCell>
                                                                    <TableCell sx={cellStyles}>{trip.tareWeight ?? "N/A"}</TableCell>
                                                                    <TableCell sx={cellStyles}>{trip.grossWeight ?? "N/A"}</TableCell>
                                                                    <TableCell sx={cellStyles}>{trip.netWeight ?? "N/A"}</TableCell>
                                                                    <TableCell sx={cellStyles}>{trip.mswType || "N/A"}</TableCell>
                                                                </React.Fragment>
                                                            ))}
                                                        </TableRow>
                                                    );
                                                })
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={43} align="center">No Data Available</TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SecondaryCollectionReport;


// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hour}:${minute}`;
};

// Styles for input and button
const inputStyle = {
    border: "1px solid #E2E2E2",
    padding: "15px",
};

const buttonStyle = {
    border: "1px solid #E2E2E2",
    borderRadius: "5px",
    color: "#fff",
};